import React, { useCallback, useRef, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { MaximizeIcon } from 'lucide-react';
import { TradingViewChart } from './TradingViewChart';
import { TerminalOverlay } from './TerminalOverlay';
const intervals = [{
  label: '1M',
  value: '1'
}, {
  label: '15M',
  value: '15'
}, {
  label: '30M',
  value: '30'
}, {
  label: '1H',
  value: '60'
}, {
  label: '1W',
  value: '1W'
}, {
  label: '1MO',
  value: '1M'
}];
export function TerminalPanel() {
  const [interval, setInterval] = useState('15');
  const [expanded, setExpanded] = useState(false);
  const lastTapRef = useRef(0);

  /* Double tap (touch) / double click (mouse) on the symbol bar opens
     the floating full-screen terminal. */
  const handleTap = useCallback(() => {
    const now = Date.now();
    if (now - lastTapRef.current < 320) {
      lastTapRef.current = 0;
      setExpanded(true);
      return;
    }
    lastTapRef.current = now;
  }, []);
  return <section id="terminal" className="border-b border-line" data-id="element-157" data-mp="ew54u0afo9i">
      <div onClick={handleTap} onDoubleClick={() => setExpanded(true)} className="flex cursor-pointer select-none flex-wrap items-center justify-between gap-x-4 gap-y-3 border-b border-line px-4 py-3 sm:px-6" data-id="element-158" data-mp="ly9cnl418o69">
        <div className="flex items-center gap-3 sm:gap-4" data-id="element-159" data-mp="vxi3i53lpmoe">
          <div className="leading-tight" data-id="element-160" data-mp="zxil1ylzydzo">
            <p className="text-[14px] font-semibold tracking-tight text-white sm:text-[15px]" data-id="element-161" data-mp="14vtsk2otkceq">
              XAU/USD
            </p>
            <p className="font-mono text-[10px] text-white/35" data-id="element-162" data-mp="19u50u8zgueuu">Gold Spot</p>
          </div>

          <span className="inline-flex items-center gap-1.5 rounded-full border border-cyan-vip/40 bg-cyan-vip/10 px-2.5 py-1" data-id="element-163" data-mp="1el3ndqb1s96j">
            <span className="relative flex h-1.5 w-1.5" data-id="element-164" data-mp="1jjex811cejor">
              <span className="absolute inline-flex h-full w-full rounded-full bg-cyan-vip opacity-60" data-id="element-165" data-mp="1nml67gfuaoyx" />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-cyan-vip" data-id="element-166" data-mp="1skv6u6kc2hrx" />
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-cyan-vip" data-id="element-167" data-mp="3onrjtpvo9kon">
              Live
            </span>
          </span>

          <p className="hidden font-mono text-[11px] text-white/35 md:block" data-id="element-168" data-mp="3kkuw5kr9yydu">
            Precio en tiempo real · TradingView
          </p>
        </div>

        <div className="flex items-center gap-2" data-id="element-169" data-mp="3tmkxbiaylbot">
          <div role="group" aria-label="Temporalidad" className="flex items-center gap-0.5 rounded-md border border-line p-0.5" data-id="element-170" data-mp="3tlt0k45ml7wy">
            {intervals.map(option => {
            const isActive = option.value === interval;
            return <button key={option.value} type="button" aria-pressed={isActive} onClick={event => {
              event.stopPropagation();
              setInterval(option.value);
            }} className={`rounded px-2 py-1.5 font-mono text-[10px] tracking-[0.1em] transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip sm:px-3 sm:text-[11px] ${isActive ? 'bg-cyan-vip/15 text-cyan-vip' : 'text-white/45 hover:text-white'}`} data-id="element-171" data-mp="l5gbv0bg4mf2">
                  {option.label}
                </button>;
          })}
          </div>

          <button type="button" onClick={event => {
          event.stopPropagation();
          setExpanded(true);
        }} aria-label="Abrir terminal en ventana flotante" className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-line text-white/50 transition-colors duration-150 ease-out hover:border-cyan-vip/50 hover:text-cyan-vip focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip" data-id="element-172" data-mp="etwyba1qg2ni">
            <MaximizeIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="1ffkqktl7rh8f" />
          </button>
        </div>
      </div>

      <div className="neon-underlight relative isolate bg-ink" data-id="element-174" data-mp="1ag85ad9zqi7y">
        <TradingViewChart interval={interval} data-id="element-175" data-mp="1aeoqkr3zgf8a" />
      </div>

      <p className="border-t border-line px-4 py-2.5 text-center font-mono text-[10px] text-white/25 sm:px-6" data-id="element-176" data-mp="15gn1npjvllow">
        XAUUSD chart by TradingView · Doble toque en la barra para pantalla
        completa
      </p>

      <AnimatePresence data-id="element-177" data-mp="wijhawkmmuyo">
        {expanded ? <TerminalOverlay interval={interval} onClose={() => setExpanded(false)} data-id="element-178" data-mp="rqjn7kr8mwa0" /> : null}
      </AnimatePresence>
    </section>;
}